import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Loader2, MessageCircle } from 'lucide-react';
import { useStartConversationMutation } from '@nimbazaar/store';

export function ChatPage() {
  const { adId, sellerId } = useParams<{ adId: string; sellerId: string }>();
  const navigate = useNavigate();
  const [startConversation] = useStartConversationMutation();
  const [error, setError] = useState('');

  useEffect(() => {
    if (!adId || !sellerId) return;

    startConversation({
      adId,
      sellerId,
      message: 'Hi, I\'m interested in your ad!',
    })
      .unwrap()
      .then((res) => {
        navigate(`/inbox/${res.data.id}`, { replace: true });
      })
      .catch((err) => {
        setError(err?.data?.error?.message || 'Failed to start conversation');
      });
  }, [adId, sellerId, startConversation, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
        <div className="text-center max-w-sm">
          <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-4">
            <MessageCircle className="w-8 h-8 text-red-400" />
          </div>
          <h2 className="text-lg font-bold text-gray-900 mb-2">Could not start chat</h2>
          <p className="text-gray-500 text-sm mb-4">{error}</p>
          <button
            onClick={() => window.history.back()}
            className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg transition-colors"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-8 h-8 text-primary-500 animate-spin mx-auto mb-3" />
        <p className="text-sm text-gray-500">Starting conversation...</p>
      </div>
    </div>
  );
}
